export interface DocumentProps {
  document_request_id: number;
  user_id: number;
  contragent: string;
  lease_number: string;
  contract_start_date: string;
  contract_end_date: string;
  description: string;
  file_path: string;
  status: number;
  request_date: string;
  card_description: string;
  choosen_location: string;
  pending_approver_id: number;
  template_name: string;
  creator_name: string;
  approver_name: string;
}

export interface DocumentListResponse {
  [key: number]: {
    data: DocumentProps[];
    total_count: number;
  };
}

export const DocumentListDefault: DocumentListResponse = {
  0: {
    data: [],
    total_count: 0,
  },
};

export interface DocumentTableResponse {
  data: DocumentProps[];
  total_count: number;
}

export const DocumentTableDefault: DocumentTableResponse = {
  data: [],
  total_count: 0,
};

export interface DocumentFilters {
  hash_pw: string | undefined;
  from_date: string | undefined;
  to_date: string | undefined;
  locations: string[] | undefined;
  template_name: string | undefined;
  contragent: string | undefined;
  lease_number: string | undefined;
  creator_name: string | undefined;
  approver_name: string | undefined;
  status: number[] | undefined;
  sort_by: string[] | undefined;
  limit: number | undefined;
  offset: number | undefined;
}

export const DocumentFiltersDefault: DocumentFilters = {
  hash_pw: undefined,
  from_date: undefined,
  to_date: undefined,
  locations: undefined,
  template_name: undefined,
  contragent: undefined,
  lease_number: undefined,
  creator_name: undefined,
  approver_name: undefined,
  status: undefined,
  sort_by: undefined,
  limit: undefined,
  offset: undefined,
};
